// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSLabelList/index.less
// module id = 964
// module chunks = 42